import { render } from "./JsLibrariesSubComponent.vue?vue&type=template&id=f46f856e"
import script from "./JsLibrariesSubComponent.vue?vue&type=script&lang=js"
export * from "./JsLibrariesSubComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__